<template>
  <div>
    <header :class="['header-main ', customClass ? 'customHead' : '']">
      <div  :class="[customClass ? 'logo-header_custom' : 'logo-header']">
        <router-link to="/home" :class="getActiveTabClass('/home')">
            <img :src="getTranslations.logo_for_branded_projects || 'static/images/logo.svg'" alt="">
        </router-link>
      </div>
      <nav :class="['main-nav main-nav--home ', customClass ? 'custom_header' : '']">
        <button v-if="!customClass()" data-menu="nav_dropdown_notif"
                :class="['nav__toggle nav__toggle_notif', (numberOfUnreadNotifications > 0)  ? 'has_notif' : '' , getActiveTabClass('/home/notifications')]"
                @click="$router.push('/home/notifications')" style="cursor:pointer"></button>
        <button data-menu="nav_dropdown_burgerMenu" :class="['nav__toggle nav__toggle_burgerMenu', isIos ? 'ui_desc_ios' : '']"><span></span></button>
        <button v-if="customClass()" data-menu="nav_dropdown_notif"
                :class="['nav__toggle nav__toggle_notif', (numberOfUnreadNotifications > 0)  ? 'has_notif' : '' , getActiveTabClass('/home/notifications')]"
                @click="$router.push('/home/notifications')" style="cursor:pointer"></button>
        <div id="nav_dropdown_burgerMenu" class="nav-dropdown nav_dropdown_burgerMenu">
          <ul>
            <li>
              <router-link to="/home/profile" :class="[getActiveTabClass('/home/profile')]" style="cursor:pointer">{{
                getTranslations.home_home_profile }}
              </router-link>
            </li>
            <li v-if="!hideWinners">
              <router-link to="/home/winners" :class="getActiveTabClass('/home/winners')" style="cursor:pointer">
                {{ getTranslations.home_home_winners }}
              </router-link>
            </li>
            <li>
              <router-link to="/home/howitworksLoggedIn" style="cursor:pointer">
                {{ getTranslations.home_home_how_it_works }}
              </router-link>
            </li>
            <li>
              <a @click.prevent="logoutUser" class="logout_menu_button" style="cursor:pointer">{{
                getTranslations.home_home_log_out }}</a>
            </li>
          </ul>
        </div>
      </nav>
    </header>

    <router-view :playGame="playGame"></router-view>

    <div class="black-overlay"></div>

    <!-- dynamically change modals -->
    <component :is="modalForHomePage"></component>


  </div>
</template>


<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Vue from 'vue';
import { handleBurger, closeTab } from '@/common/jQuery';
import IntegrationMixin from '@/common/mixins/integration';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import NewGameMixin from '@/common/mixins/home';
import RoundUpMixin from '@/common/mixins/roundUp';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import ResumeGame from './modals/ResumeGame';
import ResubscribeGame from './modals/ResubscribeGame';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import ZeroBalance from './modals/ZeroBalance';
import WelcomeSignup from './modals/WelcomeSignup';
import PrizeForFreeGame from './modals/PrizeForFreeGame';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'home',
  mixins: [IntegrationMixin, NewGameMixin, RoundUpMixin, FacebookMixin],
  data() {
    return {
      stompClient: null,
      subscription: null,
      connectionTimer: null,
      isIos: false,
      currentTabPath: null,
      showedModal: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.currentTabPath === null && to.path === '/home') {
        vm.currentTabPath = to.path;
        sessionStorage.setItem('homeCurrentTabPath', vm.currentTabPath);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    console.log(`from: ${from.path}`);
    console.log(`to: ${to.path}`);
    this.currentTabPath = to.path;
    this.storeModalForHomePage(null);
    console.log(`-------------------------------------- beforeRouteUpdate: ${this.currentTabPath} + ${sessionStorage.getItem('homeCurrentTabPath')} + ${to.path} `);
    sessionStorage.setItem('homeCurrentTabPath', to.path);
    closeTab();
    this.webSocketConnectAndReceiveServerResponse(); // only in beforeUpdate for the case where the game is finished and no reload process has been done
    next();
  },
  created() {
    this.currentTabPath = sessionStorage.getItem('homeCurrentTabPath');
    console.log(`-------------------------------------- created hook: ${this.currentTabPath} `);
    console.log('Home\'s created hook');
    console.log('this.userDetails:', this.userDetails);
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.getUserNotifications().then(() => {
      // example url for extra Notifications from SocketJS -- http://localhost:8181/api/sendNotifications?msisdn=300136987410
      this.stompClient = webSocket.getNotificationsStompClient();
      if (this.stompClient === null) {
        this.stompClient = webSocket.createNewStompClient('/notificationsData');
      }
      this.connect();
    });
  },
  mounted() {
    console.log(`-------------------------------------- Mounted hook: ${this.userDetails.availableGames}`);
    this.$nextTick(() => {
      handleBurger(ZeroBalance);
    });
    this.autoCheckIfGameToResumeExists();
  },
  updated() {
    // eslint-disable-next-line
    console.log('Username from db: ' + this.userDetails.username + ' username from Storage: ' + localStorage.getItem('username')
      + ' jwtToken From LocalStorage: ' + localStorage.getItem('jwtToken')
      + ' jwtToken From SessionStorage' + sessionStorage.getItem('jwtToken'));
    if (this.userDetails.username !== '') {
      // eslint-disable-next-line
      console.log('Home.js for skip refresh case');
      if (!((localStorage.getItem('username') === this.userDetails.username))
        && (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') === null)) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users...');
        // eslint-disable-next-line
        window.location.reload();
      }
      if (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') !== null) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users LOCAL & STORAGE...');
        sessionStorage.clear();
        // eslint-disable-next-line
        window.location.reload();
      }
    }
  },
  methods: {
    ...mapMutations('common', [
      'storeUserAvailableGames',
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'storeNotificationsFromSocket',
      'setFirstTimeEntry',
      'clearAllData',
    ]),
    ...mapMutations('game', [
      'resetPrizePostGameData',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
      'awardPrizeAction',
    ]),
    ...mapActions('profile', [
      'getUserNotifications',
    ]),
    customClass() {
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name && !this.multiOperatorInfo.multiOperatorEnabled) {
        return true;
      }
      return false;
    },
    autoCheckIfGameToResumeExists() {
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForHomePage(ResumeGame);
          this.$nextTick(() => {
            /* eslint-disable */
            // open modal
            $('.modal,.modal-overlay').fadeIn(200);
            // hide modal
            $('.modal-close, .modal-overlay').click(() => {
              /* eslint-enable */
              this.storeModalForHomePage(null);
            });
          });
        } else {
          this.methodForPopUps();
        }
      }).catch(error => console.error(error));
    },
    methodForPopUps() {
      /* eslint-disable */
      if (this.firstTimeEntry) {
        this.storeModalForHomePage(WelcomeSignup);
        this.showModal();
      } else {
        if (this.unauthorizedWinnerInfo.existPrize) {
          if (this.unauthorizedWinnerInfo.msisdn === this.userDetails.msisdn) { // case where he wins a prize and login with a different user
            this.storeModalForHomePage(PrizeForFreeGame);
            this.awardPrizeAction();
            this.showModal();
          } else {
            this.resetPrizePostGameData();
          }
        } else {
          const nowDate = new Date(moment().format('L'));
          const latestLogin = new Date(sessionStorage.getItem('zeroBalancePopUp'));
          if (((nowDate.getTime() > latestLogin.getTime()) || sessionStorage.getItem('zeroBalancePopUp') === null) && (this.userDetails.availableCoins === 0 && this.userDetails.subscribed) && (sessionStorage.getItem('homeCurrentTabPath') === '/home')) {
            this.storeModalForHomePage(ZeroBalance);
            this.showModal();
            sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
          }
          if (!this.userDetails.subscribed && (!this.gameInProgress) && sessionStorage.getItem('homeCurrentTabPath') === '/home') {
            if (this.subAndUnsubViaSMS) {
              if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                this.storeModalForHomePage(ResubscribeGameSms);
              } else {
                this.storeModalForHomePage(ResubscribeGame);
              }
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
            this.showModal();
          }
        }
      }
    },
    connect() {
      this.stompClient.connect({ Authorization: auth.getJwt() }, this.stompSuccess, this.stompFailure);
    },
    stompSuccess(frame) {
      clearTimeout(this.connectionTimer);
      // eslint-disable-next-line
      console.log(`In Home component: ${frame}`);
      console.log(`Inside Created ${this.userDetails.msisdn}`);
      console.log(`Subscribing to channel: /topic/notifications/${this.userDetails.msisdn}`);
      this.subscription = this.stompClient.subscribe(`/topic/notificationsData/${this.userDetails.msisdn}`, (response) => {
        console.log('==> Inside notification response');
        const notificationsDTO = JSON.parse(response.body);
        this.storeNotificationsFromSocket({ notifications: notificationsDTO });
        console.log('notificationsDTO');
        console.log(notificationsDTO);
      }, (errorResponse) => { // error callback
        console.log('errorResponse');
        console.log(errorResponse);
      });
    },
    stompFailure(error) {
      // console.clear();
      console.log(error);
      console.error('Lost connection to WebSocket! Reconnecting in 3 seconds...');
      clearTimeout(this.connectionTimer);
      this.connectionTimer = setTimeout(() => {
        this.stompClient = webSocket.createNewStompClient('/notificationsData');
        this.connect();
      }, 3000);
    },
    // todo DELETE and move to modals.js
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (this.firstTimeEntry) {
            this.setFirstTimeEntry(false);
            this.storeModalForHomePage(null);
            this.methodForPopUps();
          } else {
            if (!this.showedModal) {
              console.log("----------------------- Correct Exit For  Store showHideModal");
              this.resetPrizePostGameData();
              this.showedModal = true;
              this.storeModalForHomePage(null);
            } else {
              this.storeModalForHomePage(null);
            }
          }
        });
      });
      /* eslint-enable */
    },
    webSocketConnectAndReceiveServerResponse() {
      this.stompClient = webSocket.getGameBalanceStompClient();
      if (this.stompClient === null) {
        this.stompClient = webSocket.createNewStompClient('/gameBalanceData');
      }
      const connect = () => {
        this.stompClient.connect({ Authorization: auth.getJwt() }, stompSuccess, stompFailure);
      };
      const stompSuccess = (frame) => {
        clearTimeout(this.connectionTimer);
        console.log(`In Home component: ${frame}`);
        console.log(`Subscribing to channel: /topic/gameBalanceData/${this.userDetails.msisdn}`);
        this.subscription = this.stompClient.subscribe(`/topic/gameBalanceData/${this.userDetails.msisdn}`, (response) => {
          const availableGames = JSON.parse(response.body);
          console.log('availableGames:', availableGames);
          this.storeUserAvailableGames({ availableGames });
        }, (errorResponse) => { // error callback
          console.log('errorResponse');
          console.log(errorResponse);
        });
      };
      const stompFailure = (error) => {
        // console.clear();
        console.log(error);
        console.error('Lost connection to WebSocket! Reconnecting in 3 seconds...');
        clearTimeout(this.connectionTimer);
        this.connectionTimer = setTimeout(() => {
          this.stompClient = webSocket.createNewStompClient('/gameBalanceData');
          connect();
        }, 3000);
      };
      connect();
    },
    logoutUser() {
      let currentLocale = localStorage.getItem('locale');
      if (!currentLocale) currentLocale = this.getLocale;
      const soundsOn = localStorage.getItem('soundsOn');
      localStorage.clear();
      localStorage.setItem('locale', currentLocale);
      localStorage.setItem('soundsOn', soundsOn);
      sessionStorage.clear();
      if (this.userDetails.availableCoins === 0) sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
      this.clearAllData();
      if (this.facebookFunctionality && this.userDetails.facebookId && (this.token || localStorage.getItem('accessToken'))) {
        // eslint-disable-next-line
        this.logout(() => console.log('Succesful FB logout'));
      }
      window.location.reload();
      this.$router.push('/');
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },
  },
  computed: {
    ...mapState('common', [
      'logoOnFooter',
      'userAvatar',
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'modalForHomePage',
      'facebookFunctionality',
      'hideStore',
      'hideWinners',
      'multiOperatorInfo',
    ]),
    ...mapState('game', [
      'gameInProgress',
      'unauthorizedWinnerInfo',
    ]),
    ...mapState('profile', [
      'firstTimeEntry',
      'notifications',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
      'getTranslationByOperator',
    ]),
    numberOfUnreadNotifications() {
      return this.notifications.filter(notification => notification.readStatus === false).length;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue